import { useState, lazy, Suspense } from 'react'
import Link from '@mui/material/Link'
import GenericDropdown from '../../../../../../components/generic/genericDropdown'

const DisassociateCounterpartiesModal = lazy(() => import('./DisassociateCounterpartiesModal'))

const ListenersTableRowDropdown = ({ transactionCounterparty, cleanCounterparty, removeCleanedCounterparty }) => {
  const [unmergeModalVisible, setUnmergeModalVisible] = useState(false)

  const dropdownItems = [
    <Link
      component='button'
      onClick={(event) => {
        event.stopPropagation()
        setUnmergeModalVisible(true)
      }}
      underline='none'
    >
      Disassociate
    </Link>,
  ]

  return (
    <>
      <GenericDropdown dropdownItems={dropdownItems} />

      {unmergeModalVisible && (
        <Suspense fallback={<></>}>
          <DisassociateCounterpartiesModal
            modalVisible={unmergeModalVisible}
            handleCancelModal={() => setUnmergeModalVisible(false)}
            transactionCounterparty={transactionCounterparty}
            cleanCounterparty={cleanCounterparty}
            removeCleanedCounterparty={removeCleanedCounterparty}
          />
        </Suspense>
      )}
    </>
  )
}

export default ListenersTableRowDropdown
